import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'pt', label: 'Português', flag: '🇧🇷' },
    { code: 'es', label: 'Español', flag: '🇪🇸' },
  ];

  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      {languages.map(lang => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          style={{
            padding: '6px 12px',
            border: i18n.language === lang.code ? '2px solid #0066cc' : '1px solid #ddd',
            borderRadius: '4px',
            backgroundColor: i18n.language === lang.code ? '#e6f0ff' : '#fff',
            color: i18n.language === lang.code ? '#0066cc' : '#333',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: i18n.language === lang.code ? '600' : '400',
            transition: 'all 0.2s',
          }}
          title={lang.label}
        >
          {lang.flag} {lang.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
